<script setup lang="ts">
import { onMounted } from 'vue';
import { useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';

const tenantStore = useTenantStore();
const { error, message, quickbooksTokenExists, loading } = storeToRefs(tenantStore);

onMounted(async () => {
  await tenantStore.getQuickbooksAPI();
});

const authenticate = () => {
  if (tenantStore.quickbooksLink) window.location.assign(tenantStore.quickbooksLink);
};

const disconnect = async () => {
  await tenantStore.revokeQuickbooks();
  await tenantStore.tokenExists();
  tenantStore.doToast(message.value, error?.value);
};
</script>

<template>
  <Card>
    <template #header>
      <h2>Quickbooks</h2>
    </template>
    <template #content>
      <div v-if="loading">...loading</div>
      <div v-else class="flex flex-row">
        <AppButton
          text="Authenticate"
          icon-left="open_in_new"
          type="secondary"
          :disabled="quickbooksTokenExists"
          @click="authenticate"
        />
        <AppButton
          text="Disconnect"
          class="ml-3"
          icon-left="link-off"
          type="alert"
          :disabled="!quickbooksTokenExists"
          @click="disconnect"
        />
      </div>
    </template>
  </Card>
</template>

<style scoped lang="scss"></style>
